module.exports = __webpack_public_path__ + "img/meet-kristen-bottom.dfc8bee4.jpg";